/* eslint-disable no-shadow */
/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './transitionForm.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import SAVED_QUESTION from '../../../../Assets/images/svg/dar_saved_question.svg';
import { DEAL_TRANSITION_FORM } from '../../../../Constants/strings';
import PaginationButtons from './pagination';
import SAVE_ICON from '../../../../Assets/images/svg/dar_save_for_later.svg';
import SELECTED_SAVE_ICON from '../../../../Assets/images/svg/dar_selected_save_for_later.svg';
import SHOW_ALL_QUESTIONS from '../../../../Assets/images/svg/dar_show_all_question.svg';
import SimpleSnackbar from '../../../../Components/Snackbar/snackbar';
import BACK_BUTTON from '../../../../Assets/images/svg/black_back_button.svg';
import PropTypes from 'prop-types';
import { setFormValue } from '../../../../Api/request/dealDashboard';
import UseAxios from '../../../../Api/http/http';
import questions from './sales_to_ce_transitionform_data.json';
import InputField from './inputFields';
import Loader from '../../../../Components/Loader';
import { Button } from '@mui/material';
import { fetchFormValues, onSaveForLater, onShowSavedQuestions, onFileUpload, onRemoveFile, onSaveUploadFiles } from './dtFormApi';

const ProgressBar = ({ progress }) => {
  return (
    <div className="progress-bar">
      <div className="progress-fill" style={{ width: `${progress}%` }}></div>
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TransitionForm = () => {
  const query = useQuery();
  const dealId = query.get('id');
  const totalQuestions = 22; //Mandatory questions
  const questionsPerBar = 3;
  const numBars = Math.ceil(totalQuestions / questionsPerBar);
  const [answeredQuestions, setAnsweredQuestions] = useState(0);
  const [prefilledValues, setPrefilledValues] = useState({});
  const { register, handleSubmit, watch, reset, formState: { errors }, control, trigger, clearErrors } = useForm({
    mode: "onChange",
    defaultValues: prefilledValues || {},
  });
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4;
  const [showAllQuestions, setShowAllQuestions] = useState(false);
  const [savedQuestions, setSavedQuestions] = useState({});
  const [showSavedQuestions, setShowSavedQuestions] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [filteredQuestions, setFilteredQuestions] = useState(questions);
  const [questionList, setQuestionList] = useState(questions);
  const [selectedValues, setSelectedValues] = useState(prefilledValues || {});
  const navigate = useNavigate();
  const totalRecords = showSavedQuestions ? filteredQuestions.length : questionList.length;
  const [apiData, setApiData] = useState(null);
  const [currentAction, setCurrentAction] = useState('submit');
  const [isFormValid, setIsFormValid] = useState(false);
  const mandatoryQuestions = questions.filter((q) => q.question.includes('*') && !q.readOnly);
  const [loading, setLoading] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const MAX_FILE_SIZE = 1 * 1024 * 1024;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchFormValues(
        dealId, 
        setApiData, 
        setPrefilledValues, 
        setUploadedFiles, 
        setQuestionList, 
        setFilteredQuestions, 
        setSavedQuestions, 
        reset, 
        setAnsweredQuestions,
        updateOfferingAppOptions
      );
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    reset(prefilledValues);
    trigger();
  }, [prefilledValues, reset]);

  useEffect(() => {
    if (prefilledValues) {
      const normalizedValues = Object.entries(prefilledValues).reduce((acc, [key, value]) => {
        const id = key.replace('question', '');
        acc[id] = value;
        return acc;
      }, {});
      setSelectedValues(normalizedValues);
    }
  }, [prefilledValues]);

  const formValues = watch();

  useEffect(() => {
    const areAllRequiredFieldsFilled = questionList.every((q) => {
      if (q.question.includes('*') && !q.readOnly) {
        const value = formValues[`question${q.id}`] || prefilledValues[`question${q.id}`];
        if (savedQuestions?.[q.id]?.isSaved) {
          return Boolean(value);
        }
        if (q.type === 'checkbox') {
          const isValid = Array.isArray(value) && value.length > 0;
          return isValid;
        }

        if (q.type === 'radio') {
          const normalizedValue = Array.isArray(value) ? value[0] : value;
          const isValid = normalizedValue !== null && normalizedValue !== undefined && normalizedValue !== "";
          return isValid;
        }
        return Boolean(value);
      }
      return true;
    });
    setIsFormValid(areAllRequiredFieldsFilled);
  }, [formValues,prefilledValues, questionList, savedQuestions]);

  const sendPayloadToApi = async (payload) => {
    try {
      const response = await UseAxios(setFormValue(payload));
      return response;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handlePageChange = async (event, page) => {
    const currentPageFields = questionList
  .filter((q) => q.page === currentPage && !q.saveForLater)
  .flatMap((q) => 
    q.type === 'dropdown' && selectedValues?.[q.id] === 'Other'
      ? [`question${q.id}`, `question${q.id}_other`]
      : [`question${q.id}`]
  );


    Object.keys(errors).forEach((errorKey) => {
      const questionId = parseInt(errorKey.replace('question', ''), 10);
      const isSaveForLater = savedQuestions?.[questionId]?.isSaved || false;
      const question = questionList.find((q) => q.id === questionId);
      const isDropdown = question.type === 'dropdown';
      const isOtherField = errorKey.endsWith('_other');
      const dropdownValue = selectedValues?.[questionId];

      if (isSaveForLater) {
        clearErrors(errorKey);
      }
      if (isDropdown && isOtherField && dropdownValue !== 'Other') {
        clearErrors(errorKey);
      }
    });
    const isValid = await trigger(currentPageFields);
    if (!isValid) {
      const firstError = Object.keys(errors)[0];
      document.querySelector(`[name="${firstError}"]`)?.scrollIntoView({
        behavior: 'smooth',
      });
      return;
    }

    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };


  const totalPages = Math.ceil(
    (showSavedQuestions ? filteredQuestions.length : questionList.length) / pageSize
  );

  const paginatedData = (
    showSavedQuestions ? filteredQuestions : questionList
  ).slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const calculateProgress = (barIndex) => {
    const questionsPerBar = 3;
    const startQuestion = barIndex * questionsPerBar;
    const totalQuestionsInBar = Math.min(
      questionsPerBar,
      totalQuestions - startQuestion
    );
    const answeredInThisBar = Math.max(
      0,
      Math.min(answeredQuestions - startQuestion, totalQuestionsInBar)
    );

    return (answeredInThisBar / totalQuestionsInBar) * 100;
  };

  const handleSaveForLater = (questionId, conditional, registerName) => {
    onSaveForLater({
      questionId,
      conditional,
      dealId,
      stateHandlers: { savedQuestions, setSavedQuestions, setQuestionList, questions },
      snackbarHandlers: { snackbarOpen, setSnackbarMessage, setSeverity },
    });
    
  };
  
  const handleShowSavedQuestions = () => {
    onShowSavedQuestions(dealId, setFilteredQuestions, setShowSavedQuestions, setShowAllQuestions, setCurrentPage, questionList);
  };
  
  const handleFileUpload = (event, questionId) => {
    onFileUpload(event, questionId, setUploadedFiles, setSnackbarMessage, setSeverity, snackbarOpen, MAX_FILE_SIZE);
  };
  
  const handleRemoveFile = (questionId, fileIndex) => {
    onRemoveFile({
      questionId,
      fileIndex,
      uploadedFiles,
      setUploadedFiles,
      dealId,
      snackbarHandlers: {
        setSnackbarMessage,
        setSeverity,
        snackbarOpen
      }
    });
  };

  const uploadFiles = () => onSaveUploadFiles(dealId, uploadedFiles);

  const handleInputChange = (q, value, type) => {
    setSelectedValues((prevState) => {
      let selectedOptions = prevState[q.id] || [];
      let updatedState;

      if (type === 'checkbox') {
        if (selectedOptions.includes(value)) {
          selectedOptions = selectedOptions.filter((option) => option !== value);
        } else {
          selectedOptions = [...selectedOptions, value];
        }

        if (type === 'Other') {
          updatedState = {
            ...prevState,
            [q.id]: selectedOptions,
            [`${q.id}_other`]: value ,
          };
        } else {
          updatedState = {
            ...prevState,
            [q.id]: selectedOptions,
          };
        }
      } else if (type === 'radio') {
        selectedOptions = [value];
        updatedState = {
          ...prevState,
          [`question${q.id}`]: [value],
        };
      }
      else if (type === 'dropdown') {
        updatedState = {
          ...prevState,
          [q.id]: value,
        };
      } else if (type === 'Other') {
        updatedState = {
          ...prevState,
          [`${q.id}_other`]: value,
        };
      } else if (type === 'date') {
        updatedState = {
          ...prevState,
          [q.id]: value,
        };
      } else {
        selectedOptions = value;
        updatedState = {
          ...prevState,
          [q.id]: value,
        };
      }

      const isAnswerCleared = type === 'checkbox' ? selectedOptions.length === 0 : !value;

      const isMandatory = mandatoryQuestions.some((mq) => mq.id === q.id);
      const wasPreviouslyAnswered =
        mandatoryQuestions.some((mq) => mq.id === q.id) &&
        Boolean(prevState[q.id]?.length);

      if (isMandatory) {
        if (isAnswerCleared && wasPreviouslyAnswered) {
          setAnsweredQuestions((prev) => Math.max(0, prev - 1));
        } else if (!isAnswerCleared && !wasPreviouslyAnswered) {
          setAnsweredQuestions((prev) => prev + 1);
        }
      }

      const question11Saved = filteredQuestions.some(
        (filteredQ) => filteredQ.question === 'Deal Vertical*' && filteredQ.saveForLater
      );
      const question13Saved = filteredQuestions.some(
        (filteredQ) => filteredQ.question === 'Offering App*' && filteredQ.saveForLater
      );

      if ((question11Saved && question13Saved) || q.question === 'Deal Vertical*') {
        updateOfferingAppOptions(value, apiData);
      }
      return {
        ...updatedState,
        [q.id]: type === 'checkbox' || type === 'radio' ? selectedOptions : value,
      };
    });
  };

  const updateOfferingAppOptions = (dealVerticalId, masterData) => {
    const verticalOfferings= masterData.offeringByVertical;

    let combinedOptions = [];
    let inputType = 'radio';

    const idToNameMap = {
      1: 'App',
      2: 'Infra',
      3: 'Data',
      4: 'App+Data',
      5: 'Infra+Data',
      6: 'App+Infra',
      7: 'All',
    };

    const selectedVerticals = idToNameMap[dealVerticalId]?.split('+').map((v) => v.trim());

    if (selectedVerticals?.length > 1){
      inputType = 'checkbox';
    }
    if (selectedVerticals?.includes('All')) {
      combinedOptions = verticalOfferings;
      inputType = 'checkbox';
    } else {
      combinedOptions = verticalOfferings.filter((option) =>
        selectedVerticals?.includes(option.type)
      );


    }

    setQuestionList((prevQuestions) =>
      prevQuestions.map((q) =>
        q.question === 'Offering App*' ? { ...q, options: combinedOptions, type: inputType } : q
      )
    );
    setFilteredQuestions((prevQuestions) =>
      prevQuestions.map((q) =>
        q.question === 'Offering App*' ? { ...q, options: combinedOptions, type: inputType } : q
      )
    );
  };

  const isConditionalQuestionVisible = (question) => {
    if (!question.conditional) return true;

    const { questionId, showFor } = question.conditional;
    const dependentAnswer =
      selectedValues[questionId] || prefilledValues[`question${questionId}`] || [];

    const isVisible = Array.isArray(dependentAnswer)
      ? dependentAnswer.some((answer) => {
        const normalizedAnswer = String(answer);
        const isMatch = showFor.includes(normalizedAnswer);
        return isMatch;
      })
      : showFor.includes(String(dependentAnswer));
    return isVisible;
  };

  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 1000);
  };

  const preparePayloadFromForm = (data) => {
    const getProcessedValues = (question, values) => {
      if (question.type === "checkbox" || question.type === "radio") {
        return Array.isArray(values)
          ? values.filter((val) => val).map(Number)
          : values ? [Number(values)] : [];
      }
      if (question.type === "file") return data[`fileUpload${question.id}`] || [];
      if (question.type === "date") return data[`question${question.id}`] || null;
      return data[`question${question.id}`] || null;
    };
  
    const processQuestion = (question, acc) => {
      const { registerName, id, subQuestions } = question;
      acc[registerName] = getProcessedValues(question, data[`question${id}`]);
  
      // Handle 'Other' responses
      if (data[`question${id}_other`]) {
        const customDataKey = registerName === "deal_type_id" ? "deal_custom_type" : registerName.replace("id", "custom_data");
        acc[customDataKey] = data[`question${id}_other`];
      }
  
      // Process subquestions if conditions are met
      subQuestions?.forEach(({ conditional, ...subQ }) => {
        const parentValue = data[`question${conditional?.questionId}`];
        if (conditional?.showFor?.includes(String(parentValue))) {
          processQuestion(subQ, acc);
        }
      });
    };
  
    return questions.reduce((acc, question) => {
      processQuestion(question, acc);
      return acc;
    }, {});
  };
  

  const onSubmit = async (data, isFormSubmitted) => {
    const payload = preparePayloadFromForm(data);
    payload.form_submitted = isFormSubmitted;
    payload.deal_id = dealId;
    const isDraft = !isFormSubmitted;
    try {
      const response = await sendPayloadToApi(payload);
      if (Object.keys(uploadedFiles).length > 0) {
        const uploadResponse = await uploadFiles();
        if (!uploadResponse) {
          setSnackbarMessage("File upload failed. Please try again.");
          setSeverity("error");
          snackbarOpen();
          return;
        }
      }

      if (isDraft) {
        setSnackbarMessage("Form saved as draft");
        setSeverity("success");
      } else {
        const successCode = response.data.status_code;
        if (successCode === 200) {
          setSnackbarMessage("Form submitted successfully");
          setSeverity("success");
          setTimeout(() => {
            navigate('/deal-transition/dashboard');
          }, 1000);
        } else {
          setSnackbarMessage("Form submission failed");
          setSeverity("error");
        }
      }

      snackbarOpen();
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage("An error occurred during form submission");
      setSeverity('error');
      snackbarOpen();
    }
  };

  return (
    <div className="deal-transition-master-outer-layer">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="deal-transition-master-map">
            <div className="deal-transition-master-map-title">
              <button
                type="button"
                className="deal-transition-master-back-button"
                onClick={() => {
                  navigate('/deal-transition/dashboard');
                }}
              >
                <img src={BACK_BUTTON} alt="back icon" />
              </button>
              {DEAL_TRANSITION_FORM.SALES_TO_CE}
            </div>
            <div className="deal-transition-master-copy-and-save">
              <Button
                variant="text"
                style={{ color: '#6B5CE8' }}
                onClick={() => handleShowSavedQuestions()}
              >
                <img
                  src={showAllQuestions ? SHOW_ALL_QUESTIONS : SAVED_QUESTION}
                  alt="Show saved questions"
                />
                <div
                  className="deal-transition-button"
                >
                  {' '}
                  {showSavedQuestions
                    ? DEAL_TRANSITION_FORM.SHOW_ALL_QUESTIONS
                    : DEAL_TRANSITION_FORM.SHOW_SAVED_QUESTIONS}
                </div>
              </Button>
            </div>
          </div>
          <div className="progress-bar-container">
            {Array.from({ length: numBars }).map((_, index) => (
          <div key={index+1}>
                <ProgressBar progress={calculateProgress(index)} />
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
            {paginatedData.map(
              (q) =>
                isConditionalQuestionVisible(q) && (
                  <div className="panel-container" key={q.id}>
                    <InputField
                      q={q}
                      register={register}
                      handleInputChange={handleInputChange}
                      errors={errors}
                      currentAction={currentAction}
                      selectedValues={selectedValues}
                      prefilledValues={prefilledValues}
                      control={control}
                      savedQuestions={savedQuestions}
                      handleFileUpload={handleFileUpload}
                      handleRemoveFile={handleRemoveFile}
                      uploadedFiles={uploadedFiles}
                    />
                    {q?.subQuestions?.map(
                      (subQ) =>
                        isConditionalQuestionVisible(subQ) && (
                          <InputField
                            key={subQ.id}
                            q={subQ}
                            register={register}
                            handleInputChange={handleInputChange}
                            errors={errors}
                            currentAction={currentAction}
                            selectedValues={selectedValues}
                            prefilledValues={prefilledValues}
                            control={control}
                            savedQuestions={savedQuestions}
                            handleFileUpload={handleFileUpload}
                            handleRemoveFile={handleRemoveFile}
                            uploadedFiles={uploadedFiles}
                          />
                        )
                    )}

                    <div className="save-for-later">
                      <Button
                        variant="text"
                        style={{ color: '#6B5CE8' }}
                        onClick={() => {
                          handleSaveForLater(q.id, q.conditional, q.registerName)
                        }}
                      >
                        <img
                          key={savedQuestions[q.id]}
                          src={
                            savedQuestions[q.id]?.isSaved
                              ? SELECTED_SAVE_ICON
                              : SAVE_ICON
                          }
                          alt="Save for later"
                          className="save-icon"
                        />
                      </Button>
                    </div>
                  </div>
                )
            )}
          </form>
          <div className="pagination">
            {totalRecords > 0 ? (
              <PaginationButtons
                currentPage={currentPage}
                pageSize={pageSize}
                filteredSortedData={showSavedQuestions ? filteredQuestions : questionList}
                handlePageChange={handlePageChange}
                totalPages={totalPages}
                totalRecords={totalRecords}
                isFormValid={isFormValid}
                handleSaveAsDraft={() => {
                  setCurrentAction('draft');
                  handleSubmit((data) => onSubmit(data, false))();
                }}
                handleSubmitForm={() => {
                  setCurrentAction('submit');
                  handleSubmit((data) => onSubmit(data, true))();
                }}
              />
            ) : (
              <p>{DEAL_TRANSITION_FORM.NO_RECORDS_TO_DISPLAY}</p>
            )}
          </div>
          <SimpleSnackbar
            open={openSnackbar}
            message={snackbarMessage}
            severity={severity}
            alertCss={`'add-snackbar'} ${severity}`}
          />
        </>
      )}
    </div>
  );
};
export default TransitionForm;